import React, { useState, useEffect } from "react";
import { useInView } from "react-intersection-observer";

export default function HeadingWithAnimation() {
  const [isVisible, setIsVisible] = useState(false);
  const { ref, inView } = useInView({
    triggerOnce: true, // Only trigger once
    threshold: 0.5, // 50% of the target element is visible
  });

  useEffect(() => {
    if (inView) {
      setIsVisible(true);
    } else {
      setIsVisible(false); // Reset isVisible state when out of view
    }
  }, [inView]);

  return (
    <div
      ref={ref}
      className={`mx-auto mb-8 text-center ${isVisible ? "slide-in-left" : ""}`}
    >
      <h2 className="font-display text-3xl text-jacarta-700 dark:text-white lg:text-4xl xl:text-6xl text-center uppercase">
        WHAT <span className="animate-gradient"> WE DO</span>
      </h2>
      <p className="text-lg dark:text-jacarta-300">
        We leverage technology to make it easy to engage, inform, inspire, and empower individuals and communities <br/> to address pressing environmental and social challenges.
        <br></br>
        <br></br>
      </p>
    </div>
  );
}
